import { Modal } from 'antd';
import React from "react";
import { useSelector } from 'react-redux';

export default function LoadingSpinner() {
    const isLoading = useSelector((state: any) => state.refreshLoadedFile.isLoading);

    return (
        <Modal
            footer={null}
            closable={false}
            open={isLoading}
            destroyOnHidden={true}
        >
        </Modal>
    );
}